export default __webpack_public_path__ + "static/RTG_PDP_LOGO_BEAUTYREST_320x100-562e0c91f795d77b0ebd6c2ef41e6a97.png";